/** @format — Normalize documents list API payloads */

import type { ApiDocument, DocumentsListResponse } from "../types";

export function unwrapDocumentsResponse(payload: unknown): DocumentsListResponse {
  const body = (payload ?? {}) as Record<string, unknown>;
  const nested = (body.data ?? {}) as Record<string, unknown>;

  let items: ApiDocument[] = [];
  if (Array.isArray(body.data)) {
    items = body.data as ApiDocument[];
  } else if (Array.isArray(nested.documents)) {
    items = nested.documents as ApiDocument[];
  } else if (Array.isArray(body.documents)) {
    items = body.documents as ApiDocument[];
  } else if (Array.isArray(nested.items)) {
    items = nested.items as ApiDocument[];
  }

  const total =
    (typeof body.total === "number" ? body.total : undefined) ??
    (typeof nested.total === "number" ? nested.total : undefined) ??
    items.length;

  return {
    success: body.success !== false,
    data: items,
    total,
    page: typeof body.page === "number" ? body.page : undefined,
    pageSize: typeof body.pageSize === "number" ? body.pageSize : undefined,
    message: typeof body.message === "string" ? body.message : undefined,
  };
}
